import * as timeZones from './timeZones.json';
const TimeZonesMgrFactory = () => {
    return {
        getTimeZones() {
            return timeZones;
        },
    };
};
export default TimeZonesMgrFactory;
